import { ApiClient } from "../config/axiosConfig";
import { IPaginatedResponse } from "../models/Pagination";
import {
  ICreatePurchaseAwb,
  ICreatePurchaseOrder,
  ICreatePurchaseReceipt,
  IPurchaseFilter,
  IPurchaseOrder,
  IPurchaseOrderDetail,
  IPurchaseOrderOverview,
  IPurchaseReceipt,
  IPurchaseRequest,
  IPurchaseRequestDetail,
  IPurchaseSupplier,
  IUpdatePurchaseOrder,
} from "../models/Purchase";

export const purchaseService = {
  getAllPurchases: async (params: IPurchaseFilter) => {
    const response = await ApiClient.GET<IPaginatedResponse<IPurchaseRequest>>(
      "/purchase-requests",
      params,
    );
    return response;
  },
  getPurchaseByAlias: async (alias: string) => {
    const response = await ApiClient.GET<IPurchaseRequestDetail>(
      `/purchase-requests/${alias}`,
    );
    return response;
  },
  getPurchaseRequestAssignments: async (params: IPurchaseFilter) => {
    const response = await ApiClient.GET<IPaginatedResponse<IPurchaseRequest>>(
      `/purchase-requests/my-assignments`,
      params,
    );
    return response;
  },

  approvePurchaseRequest: async (id: number) => {
    const response = await ApiClient.PATCH(`/purchase-requests/${id}/approve`);
    return response;
  },
  assignPurchaseRequest: async (id: number, assigneeId: string) => {
    const response = await ApiClient.PATCH(`/purchase-requests/${id}/assign`, {
      assigneeId,
    });
    return response;
  },

  getPurchaseRequestOverview: async () => {
    const response = await ApiClient.GET<IPurchaseOrderOverview>(
      `/purchase-requests/overview`,
    );
    return response;
  },
  createPurchaseReceipt: async (data: ICreatePurchaseReceipt) => {
    const response = await ApiClient.POST(`/purchase-receipt`, data);
    return response;
  },
  getPurchaseReceipts: async (params: IPurchaseFilter) => {
    const response = await ApiClient.GET<IPaginatedResponse<IPurchaseReceipt>>(
      `/purchase-receipt`,
      params,
    );
    return response;
  },
  createPurchaseOrder: async (data: ICreatePurchaseOrder) => {
    const response = await ApiClient.POST<IPurchaseOrder>(
      `/purchase-orders`,
      data,
    );
    return response;
  },
  getPurchaseOrder: async (params: IPurchaseFilter) => {
    const response = await ApiClient.GET<IPaginatedResponse<IPurchaseOrder>>(
      `/purchase-orders`,
      params,
    );
    return response;
  },
  getPurchaseOrderByPoNumber: async (poNumber: string) => {
    const response = await ApiClient.GET<IPurchaseOrderDetail>(
      `/purchase-orders/order/${poNumber}`,
    );
    return response;
  },
  getPurchaseOrderByPurchaseRequestId: async (purchaseRequestId: number) => {
    const response = await ApiClient.GET<IPurchaseOrder[]>(
      `/purchase-orders/request/${purchaseRequestId}`,
    );
    return response;
  },
  updatePurchaseOrder: async (id: number, data: IUpdatePurchaseOrder) => {
    const response = await ApiClient.PUT<IPurchaseOrderDetail>(
      `/purchase-orders/${id}`,
      data,
    );
    return response;
  },
  sendPurchaseOrder: async (id: number) => {
    const response = await ApiClient.PATCH<{
      message: string;
      pONumber: string;
      status: string;
    }>(`/purchase-orders/${id}/send`);
    return response;
  },
  createPurchaseAwb: async (data: ICreatePurchaseAwb) => {
    const response = await ApiClient.POST(`/purchase-awbs`, data);
    return response;
  },
  getPurchaseAwbByPurchaseOrderId: async (purchaseOrderId: number) => {
    const response = await ApiClient.GET(`/purchase-awbs/${purchaseOrderId}`);
    return response;
  },
  getPurchaseSupplier: async (query: IPurchaseFilter) => {
    const response = await ApiClient.GET<IPaginatedResponse<IPurchaseSupplier>>(
      `/suppliers`,
      query,
    );
    return response;
  },
  createSupplier: async (data: Omit<IPurchaseSupplier, "id">) => {
    const response = await ApiClient.POST<IPurchaseSupplier>(
      `/suppliers`,
      data,
    );
    return response;
  },
  updateSupplier: async (id: number, data: Omit<IPurchaseSupplier, "id">) => {
    const response = await ApiClient.PUT<IPurchaseSupplier>(
      `/suppliers/${id}`,
      data,
    );
    return response;
  },
  deleteSupplier: async (id: number) => {
    const response = await ApiClient.DELETE(`/suppliers/${id}`);
    return response;
  },
};
